import type { TData } from "../types";

export const findLastFilledRow = (data: TData): number => {
  for (let rowIndex = data.length - 1; rowIndex >= 0; rowIndex--) {
    const row = data[rowIndex];
    const hasValues = row.some((cell) => !!cell?.value);
    if (hasValues) return rowIndex;
  }
  return -1;
};
